import robotPhoto from "../../Assets/Images/robot_operation.jpeg";
import bhuhitAgriDashboad from "../../Assets/Images/Bhuhit_AgriDashboard.jpeg";
import bhuhitEOVideoMarathi from "../../Assets/Videos/Bhuhit_EO_Video_Marathi.mp4";
import bhuhitEOVideoHindi from "../../Assets/Videos/Bhuhit_EO_Video_Hindi.mp4";
import bhuhitNCO from "../../Assets/Videos/Bhuhit_N_Cloud_Operation.mp4";
import bhuhitNRO from "../../Assets/Videos/Bhuhit_N_Remote_Operation.mp4";

// Videos and photos shown on the login page.
// Put video files in  public/videos/  and photos in  public/images/,
// then add one line per file here (src starts with /videos/ or /images/).
export const MEDIA = [
    { type: "video", src: bhuhitEOVideoMarathi, title: "Bhuhit Agri Earth Observation" },
    { type: "video", src: bhuhitEOVideoHindi, title: "Bhuhit Agri Earth Observation" },
    { type: "video", src: bhuhitNCO, title: "Bhuhit Cloud Robot Operation" },
    { type: "video", src: bhuhitNRO, title: "Bhuhit Remote Robot Operation" },
    //{ type: "video", src: "/Videos/Bhuhit N Remote Operation1.mp4", title: "Bhuhit Remote Robot Operation" },
    { type: "image", src: robotPhoto, title: "Bhuhit Agri Robot spraying in the field" },
    { type: "image", src: bhuhitAgriDashboad, title: "Bhuhit Agri Dashboard: Farm Monitoring from Satellite Data" },
    // { type: "video", src: "/videos/grass-cutting.mp4", title: "Grass cutting" },
    // { type: "image", src: "/images/sowing.jpg", title: "Sowing" },
];

// To add a language, add one entry here (speech = browser voice code)
export const LANGS = {
    en: {
        label: "English", speech: "en-IN",
        headline: "See your farm from space. Run it from the cloud.",
        sub: "Satellite crop intelligence in your language, and cloud-controlled robots for grass cutting, spraying and sowing.",
        login: "Login", watch: "Watch video", listen: "Listen", stop: "Stop", gallery: "Videos & photos",
        pillarsTitle: "One cloud platform",
        pillars: [
            ["Operation", "Run one robot or many from the cloud."],
            ["Monitoring", "Live view of robots and farms."],
            ["Reporting", "Reports to measure efficacy."],
            ["Analytics", "Insights from robot and satellite data."],
        ],
        worksTitle: "Our work: Robot for Welfare of Soil",
        works: [
            ["Agri Robot", "Grass cutting, spraying, sowing and harvesting with the Bhuhit Agri Robot."],
            ["SunVeg Dryer", "Drying of farm produce with the SunVeg Dryer."],
            ["Bhu-Up", "Natural weed control and soil care for healthier, organic farming."],
            ["AI crop and herb detection", "AI on the Bhuhit Agri Robot recognises herbs and crops in the field."],
            ["Satellite Agri Dashboard", "Crop health, soil moisture, soil temperature and forecasts from satellite data."],
            ["Cloud operation & analytics", "Operate, monitor and report on many robots from one cloud platform."],
        ],
        instTitle: "Built for farmers",
        farmersText: "Simple tools in your own language: see your fields from satellite, run robots from the cloud and get clear reports.",
        inst: [
            ["Field-level GPS maps", "Every farm mapped and configured, ready for planning and review."],
            ["Reports and analytics", "Operation and crop reports to measure results and efficacy."],
            ["Regional-language access", "Dashboards and voice reports in the farmer's own language."],
            ["Remote monitoring", "Watch robots and farms from anywhere, and take over by joystick when needed."],
        ],
        ctaTitle: "Start with Bhuhit",
        ctaText: "Log in to run your robots and see your farms.",
    },
    mr: {
        label: "मराठी", speech: "mr-IN",
        headline: "तुमची शेती अंतराळातून पाहा. क्लाउडवरून चालवा.",
        sub: "तुमच्या भाषेत उपग्रह-आधारित पीक माहिती आणि गवत कापणी, फवारणी व पेरणीसाठी क्लाउडवरून चालणारे रोबोट.",
        login: "लॉगिन", watch: "व्हिडिओ पाहा", listen: "ऐका", stop: "थांबवा", gallery: "व्हिडिओ आणि फोटो",
        pillarsTitle: "एकच क्लाउड व्यासपीठ",
        pillars: [
            ["संचालन", "एक किंवा अनेक रोबोट क्लाउडवरून चालवा."],
            ["निरीक्षण", "रोबोट आणि शेतांचे थेट दर्शन."],
            ["अहवाल", "परिणाम मोजण्यासाठी अहवाल."],
            ["विश्लेषण", "रोबोट व उपग्रह माहितीतून अंतर्दृष्टी."],
        ],
        worksTitle: "आमचे कार्य: Robot for Welfare of Soil",
        works: [
            ["कृषी रोबोट", "भूहित कृषी रोबोटद्वारे गवत कापणी, फवारणी, पेरणी आणि काढणी."],
            ["सनव्हेज ड्रायर", "सनव्हेज ड्रायरने शेतमाल वाळवणे."],
            ["भू-अप", "आरोग्यदायी सेंद्रिय शेतीसाठी नैसर्गिक तण नियंत्रण आणि मातीची निगा."],
            ["एआय पीक व वनस्पती ओळख", "भूहित कृषी रोबोटवरील एआय शेतातील औषधी वनस्पती व पिके ओळखते."],
            ["उपग्रह कृषी डॅशबोर्ड", "उपग्रह माहितीवरून पीक आरोग्य, मातीतील ओलावा, मातीचे तापमान आणि अंदाज."],
            ["क्लाउड संचालन व विश्लेषण", "एकाच क्लाउड व्यासपीठावरून अनेक रोबोटचे संचालन, निरीक्षण व अहवाल."],
        ],
        instTitle: "शेतकऱ्यांसाठी",
        farmersText: "तुमच्या स्वतःच्या भाषेत सोपी साधने: उपग्रहावरून शेते पाहा, क्लाउडवरून रोबोट चालवा आणि स्पष्ट अहवाल मिळवा.",
        inst: [
            ["शेताचे जीपीएस नकाशे", "प्रत्येक शेताचा नकाशा व कॉन्फिगरेशन, नियोजन आणि आढाव्यासाठी तयार."],
            ["अहवाल व विश्लेषण", "कामाचा परिणाम मोजण्यासाठी संचालन व पीक अहवाल."],
            ["प्रादेशिक भाषेत सुविधा", "शेतकऱ्याच्या स्वतःच्या भाषेत डॅशबोर्ड आणि आवाज अहवाल."],
            ["दूरस्थ निरीक्षण", "कुठूनही रोबोट व शेतांवर लक्ष ठेवा; गरज पडल्यास जॉयस्टिकने ताबा घ्या."],
        ],
        ctaTitle: "भूहितसह सुरुवात करा",
        ctaText: "तुमचे रोबोट चालवण्यासाठी आणि शेते पाहण्यासाठी लॉगिन करा.",
    },
    hi: {
        label: "हिन्दी", speech: "hi-IN",
        headline: "अपने खेत को अंतरिक्ष से देखें। क्लाउड से चलाएँ।",
        sub: "आपकी भाषा में उपग्रह-आधारित फ़सल जानकारी, और घास कटाई, छिड़काव व बुवाई के लिए क्लाउड से चलने वाले रोबोट।",
        login: "लॉगिन", watch: "वीडियो देखें", listen: "सुनें", stop: "रोकें", gallery: "वीडियो और फोटो",
        pillarsTitle: "एक क्लाउड प्लेटफ़ॉर्म",
        pillars: [
            ["संचालन", "एक या कई रोबोट क्लाउड से चलाएँ।"],
            ["निगरानी", "रोबोट और खेतों का लाइव दृश्य।"],
            ["रिपोर्ट", "असर मापने के लिए रिपोर्ट।"],
            ["विश्लेषण", "रोबोट और उपग्रह डेटा से जानकारी।"],
        ],
        worksTitle: "हमारा काम: Robot for Welfare of Soil",
        works: [
            ["कृषि रोबोट", "भूहित कृषि रोबोट से घास कटाई, छिड़काव, बुवाई और कटाई।"],
            ["सनवेज ड्रायर", "सनवेज ड्रायर से उपज की सुखाई।"],
            ["भू-अप", "स्वस्थ जैविक खेती के लिए प्राकृतिक खरपतवार नियंत्रण और मिट्टी की देखभाल।"],
            ["एआई फ़सल और जड़ी-बूटी पहचान", "भूहित कृषि रोबोट पर एआई खेत में जड़ी-बूटियों और फ़सलों को पहचानता है।"],
            ["सैटेलाइट कृषि डैशबोर्ड", "उपग्रह डेटा से फ़सल स्वास्थ्य, मिट्टी की नमी, मिट्टी का तापमान और पूर्वानुमान।"],
            ["क्लाउड संचालन और विश्लेषण", "एक ही क्लाउड प्लेटफ़ॉर्म से कई रोबोट का संचालन, निगरानी और रिपोर्ट।"],
        ],
        instTitle: "किसानों के लिए",
        farmersText: "अपनी भाषा में आसान साधन: उपग्रह से खेत देखें, क्लाउड से रोबोट चलाएँ और साफ़ रिपोर्ट पाएँ।",
        inst: [
            ["खेत के जीपीएस नक्शे", "हर खेत का नक्शा और कॉन्फ़िगरेशन, योजना और समीक्षा के लिए तैयार।"],
            ["रिपोर्ट और विश्लेषण", "काम का असर मापने के लिए संचालन और फ़सल रिपोर्ट।"],
            ["क्षेत्रीय भाषा में सुविधा", "किसान की अपनी भाषा में डैशबोर्ड और आवाज़ रिपोर्ट।"],
            ["दूर से निगरानी", "कहीं से भी रोबोट और खेतों पर नज़र रखें; ज़रूरत पर जॉयस्टिक से नियंत्रण लें।"],
        ],
        ctaTitle: "भूहित के साथ शुरू करें",
        ctaText: "अपने रोबोट चलाने और खेत देखने के लिए लॉगिन करें।",
    },
};

export const PILLAR_ICONS = ["fa-play-circle", "fa-eye", "fa-file-text-o", "fa-area-chart"];
export const WORK_ICONS = ["fa-cogs", "fa-sun-o", "fa-leaf", "fa-eye", "fa-globe", "fa-dashboard"];
export const INST_ICONS = ["fa-map-marker", "fa-file-text-o", "fa-language", "fa-desktop"];